import React from 'react';
import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import { Box } from '@eds-web/react';

const LoadingContainer = styled(Box)`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const Loading = () => (
    <LoadingContainer textAlign="center" marginTop="10vh">
        <CircularProgress />
    </LoadingContainer>
);
